import { render, staticRenderFns } from "./tag_list.vue?vue&type=template&id=0723b21d&scoped=true&"
import script from "./tag_list.vue?vue&type=script&lang=js&"
export * from "./tag_list.vue?vue&type=script&lang=js&"
import style0 from "./tag_list.vue?vue&type=style&index=0&id=0723b21d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723b21d",
  null
  
)

export default component.exports